import Vue from 'vue'

const client = Vue.prototype.$api

export default {
    // Variables
    createTestSession (smallToken) {
        return client.get('webapp/VideoTestSessionController',  { params: { smallToken: smallToken } })
    },
    getVideoSessionUrl (appointmentId) {
        return client.get('webapp/VideoSession/urlByAppointment',  { params: { appointmentId: appointmentId } })
    }
}


// WEBPACK FOOTER //
// ./src/repositories/VideoRepository.js